import { render } from "./Buttons.vue?vue&type=template&id=b4dbcfc8"
import script from "./Buttons.vue?vue&type=script&lang=js"
export * from "./Buttons.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Input/Buttons.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b4dbcfc8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b4dbcfc8', __exports__)) {
    api.reload('b4dbcfc8', __exports__)
  }
  
  module.hot.accept("./Buttons.vue?vue&type=template&id=b4dbcfc8", () => {
    api.rerender('b4dbcfc8', render)
  })

}


export default __exports__